import Vue from 'vue'
// 阻止type="number"鼠标滚动改变数值
Vue.directive( 'stopNumberMousewheel', {
  inserted: function ( el ) {
    const ele = el.tagName === 'INPUT' ? el : el.querySelector( 'input' )
    ele.addEventListener( "mousewheel", () => {
     ele.blur();
    } )
  }
} )